import React from "react";
const IconInfo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <circle cx="10" cy="10" r="6.1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM10 5.5C10.5523 5.5 11 5.94772 11 6.5V6.55C11 7.10228 10.5523 7.55 10 7.55C9.44772 7.55 9 7.10228 9 6.55V6.5C9 5.94772 9.44772 5.5 10 5.5ZM9 8.55078V13.5508H11V8.55078H9Z"
      fill="currentColor"
    />
  </svg>
);
export default IconInfo;
